import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filter: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: 20,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  filterBy: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 20,
    '& p': {
      fontStyle: 'italic',
      fontWeight: '600',
      marginRight: 10,
    },
    '@media (max-width: 550px)': {
      marginRight: 7,
    },
    '@media (max-width: 400px)': {
      '& p': {
        fontSize: '0.75em',
      },
    },
  },
  toggleText: {
    color: '#5C5C5C',
  },
  select: {
    '&:before': {
      borderBottom: `2px solid ${theme.palette.primary.main} !important`,
    },
    '&:after': {
      borderBottom: `2px solid ${theme.palette.secondary.main} !important`,
    },
    '& .MuiSelect-selectMenu': {
      textTransform: 'uppercase',
      fontWeight: '600',
      color: theme.palette.secondary.main,
      '@media (max-width: 550px)': {
        fontSize: '1em',
      },
      '@media (max-width: 400px)': {
        fontSize: '0.85em',
      },
    },
    '& svg': {
      color: theme.palette.primary.main,
      right: -3,
      width: '0.8em',
      height: '0.8em',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      paddingRight: 17,
    },
  },
  legendWrapper: {
    width: '100%',
    minHeight: 25,
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
  },
  legends: {
    display: 'flex',
    margin: '0 auto',
    flexWrap: 'wrap',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    fontSize: '0.9em',
    '@media (max-width: 550px)': {
      padding: '5px',
      fontSize: '0.8em',
    },
  },
  legendColor: {
    width: 10,
    height: 10,
    marginRight: 5,
  },
  legendText: {
    fontSize: '.9em',
  },
}));

export default useStyles;
